import cx from 'classnames';
import type { FunctionComponent } from 'react';

import { useBoardSwitcherMode } from '@trello/board-switcher';
import { useFeatureGate } from '@trello/feature-gate-client';
import {
  useAreMultiplePanelsOpen,
  useIsSwitcherPanelOpen,
  useSplitScreenSharedState,
} from '@trello/split-screen';

import { SearchField } from './SearchField';
import { ToggleLayoutButton } from './ToggleLayoutButton';
import { TogglePanelButton } from './TogglePanelButton';

import * as styles from './BoardSwitcherHeader.module.less';

interface BoardSwitcherHeaderProps {
  isPanel?: boolean;
}

export const BoardSwitcherHeader: FunctionComponent<
  BoardSwitcherHeaderProps
> = ({ isPanel }) => {
  const { value: isBoardSwitcherPanelEnabled } = useFeatureGate(
    'billplat_board_switcher_panel',
  );

  const mode = useBoardSwitcherMode();

  const { configuration } = useSplitScreenSharedState();
  const isSwitcherPanelOpen = useIsSwitcherPanelOpen();
  const areMultiplePanelsOpen = useAreMultiplePanelsOpen();

  const isSwitcherOnlyPanel =
    mode === 'panel' && isSwitcherPanelOpen && !areMultiplePanelsOpen;

  const shouldShowToggleLayoutButton =
    mode !== 'panel' && configuration !== 'tabs';

  const shouldShowTogglePanelButton =
    isBoardSwitcherPanelEnabled && !isSwitcherOnlyPanel;

  return (
    <div
      className={cx({
        [styles.container]: true,
        [styles.panel]: isPanel,
      })}
    >
      <SearchField />
      {shouldShowToggleLayoutButton && <ToggleLayoutButton />}
      {shouldShowTogglePanelButton && <TogglePanelButton />}
    </div>
  );
};
